import React from 'react';
import axios from 'axios';
import Helmet from 'react-helmet';

// styles
import { Grid, Row, Col, Button, Label } from 'react-bootstrap/lib';
import { ConfirmUploadBankCsv } from '../components/ConfirmationModals';

export default class UploadAddressCsv extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      selectedFile: null,
      isFileSelected: false,
      error: null,
      isSuccessful: false,
    };
  }

  onChangeHandler = (event) => {
    this.setState({
      selectedFile: event.target.files[0],
      isFileSelected: true,
      isSuccessful: false,
      error: null,
    });
  };

  handleSubmission = () => {
    this.setState({ isLoading: true, isSuccessful: false, error: null });

    const formData = new FormData();

    formData.append('file', this.state.selectedFile);

    axios({
      url: '/api/addresses/upload',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      method: 'post',
    })
      .then(() => this.setState({ isLoading: false, isSuccessful: true }))
      .catch(() => this.setState({ isLoading: false, error: 'Invalid file' }));
  };

  render() {
    const { isLoading, isFileSelected, error, isSuccessful } = this.state;

    return (
      <div>
        <Helmet title="Upload Address Information" />
        {isSuccessful ? <ConfirmUploadBankCsv /> : null}
        <Grid>
          <Row>
            <Col xs={12}>
              <p>
                This functionality allows you to upload your own Address information so that the
                information csv file which will be available for later use.
              </p>

              <br />

              <p>
                In the case that there is a field that has a comma (,) in its name, then the field
                must be wrapped in double quotes ("), ..."{' '}
              </p>

              <br />
              <form>
                <input name="file" type="file" accept=".csv" onChange={this.onChangeHandler} />

                <br />
                <Button
                  onClick={this.handleSubmission}
                  disabled={isLoading || !isFileSelected}
                  bsStyle={isSuccessful ? 'success' : 'primary'}
                  bsSize="lg"
                >
                  {isSuccessful ? 'Uploaded' : 'Upload'}
                </Button>
              </form>
              <p>{error && <Label bsStyle="danger">{error}</Label>}</p>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
